import classNames from 'classnames';
import { Controller, useFormContext } from 'react-hook-form';
import { faBookmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormValues } from '../hooks/useFormInitialisation';
import { useTranslations } from 'next-intl';

type Props = {
  placeholder?: string;
};

const SourceField = ({ placeholder }: Props) => {
  const t = useTranslations();
  const { control } = useFormContext<FormValues>();

  return (
    <div className={styles.source.container}>
      <FontAwesomeIcon
        icon={faBookmark}
        className={styles.source.icon}
        aria-hidden="true"
      />

      <Controller
        control={control}
        name="source"
        render={({ field: { onChange, value, onBlur } }) => (
          <input
            id={'source'}
            autoComplete="off"
            value={value ?? ''}
            onChange={onChange}
            onBlur={onBlur}
            className={styles.source.input}
            placeholder={placeholder ?? t('memoComposer.source')}
          />
        )}
      />
    </div>
  );
};

export default SourceField;

const styles = {
  source: {
    container: 'flex items-center gap-1.5 border-none outline-hidden',
    icon: 'shrink-0 text-xs text-ink-tertiary',
    input: classNames(
      'w-full bg-transparent font-normal text-sm text-ink-primary border-none outline-hidden focus:outline-hidden',
      'focus:border-transparent focus:ring-0 caret-blue-600',
      'p-0',
    ),
  },
};
